// add transaltions
export const fiMenus = (logoUrl) => ({
    type: 'public',
    logoItems: [
        {
            id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
            href: '/fi-fi/',
            url: logoUrl,
            alt: 'Raisin',
        },
    ],
    navItems: [],
    actionItems: [
        {
            id: '659be2f1-cdfa-4666-bcbb-edf874ad83ce',
            title: 'Kirjaudu sisään',
            href: '/fi-fi/login/',
            type: 'login',
        },
    ],
});
//# sourceMappingURL=fiMenus.js.map